/**
 *
 * This file for individual filter applied to dataset
 *
 * if anchorDate  based on specificDate the date is to be stored in userSelection[0] of "filterfieldData"
 *
 * "filterFieldDate"  store all the values regarding the filter
 *
 * on each change in "filterFieldDate" "setDataSetFilterArray" is to be called as it update  "datasetFilterArray"
 * in canvax.tsx that keep tracks of all the applied filters in dataset
 *
 *
 * date format yyyy-MM-dd
 */

import React, { useEffect, useState, useRef } from 'react';
import FetchData from '../ServerCall/FetchData';
import '../ChartAxes/Card.css';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import '../ChartFieldFilter/UserFilterCard.css';
import MenuOption from './MenuOption';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { IFilter, IRelativeCondition } from './types/BottomBarInterfaces';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import {
  datePatternCollections,
  datePatternSearchConditionCollections,
  searchConditionOperatorText,
  withPatternCollections,
} from '../FilterUtils/FilterPatternCollection';
import { SelecPickListCard } from '../FilterUtils/PickList';
import { SelecTillDate } from '../FilterUtils/TillDate';
import { CustomCard } from '../FilterUtils/SearchCondition';
import { SelecRelativeFilterCard } from '../FilterUtils/RelativeFilter';
import { handleKeyDown } from '../CommonFunctions/CommonFunctions';
import { DropDownForDatePattern } from '../FilterUtils/DropDownComponent';
import { RootState } from '../../redux';
import { convertKeysToLowercase } from '../Calculations/utils';
import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import { TAlert } from '../../types/types';
import { Typography } from '@mui/material';
import { fontSize } from '../..';
import { palette } from '../..';
export interface FilterElementProps {
  filter: IFilter;
  dbConnectionId: any;
  editMode?: boolean;
  flatFileId: string;
  schema?: string;
  setDataSetFilterArray: React.Dispatch<React.SetStateAction<IFilter[]>>;
  canEdit: boolean;
}

const FilterElement = ({
  filter,
  dbConnectionId,
  flatFileId = '',
  schema: filterFieldSchema,
  setDataSetFilterArray,
  canEdit,
}: FilterElementProps) => {
  // filterFieldData useRef is used for managing filters ,the useStates are for rendering
  const filterFieldData = useRef<IFilter>({
    filterType:
      filter.filterType ||
      filter.filterType ||
      (['decimal', 'float', 'double', 'integer'].includes(filter.dataType)
        ? 'searchCondition'
        : 'pickList'),
    tableId: filter.tableId,
    fieldName: filter.fieldName,
    dataType: filter.dataType,
    shouldExclude: filter.shouldExclude || false,
    timeGrain: filter.timeGrain || 'year',
    operator: filter.operator,
    userSelection: filter.userSelection || [],
    isTillDate: filter.isTillDate || false,
    uid: filter.uid,
    tableName: filter.tableName,
    database: filter.database,
    schema: filter.schema,
    relativeCondition: (filter.relativeCondition as IRelativeCondition) ?? {
      from: ['last', '1', 'year'],
      to: ['next', '1', 'year'],
      anchorDate: 'today',
    },
    connectionId: filter.connectionId,
  });
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [picklist, setPickList] = useState<any>(null);
  const [searchCondition, setSearchCondition] = useState(filter.operator);

  const { token } = useSelector((state: RootState) => ({
    token: state.isLogged.accessToken,
  }));

  const getValidDateOrString = (value: any, dataType: string) => {
    if ((dataType === 'date' || dataType === 'timestamp') && !isNaN(new Date(value).getTime())) {
      return new Date(value); // Valid date
    }
    return value || ''; // Return original value if not date/timestamp or invalid date
  };

  const [conditionValue, setConditionValue] = useState<number | string | Date>(
    getValidDateOrString(filter.userSelection[0], filter.dataType),
  );

  const [conditionValue2, setConditionValue2] = useState<number | string | Date>(
    getValidDateOrString(filter.userSelection[1], filter.dataType),
  );

  const [timeGrain, setTimeGrain] = useState(filter.timeGrain || 'year');
  const [anchorDate, setAnchorDate] = useState<string | Date>(
    filter.relativeCondition?.anchorDate || 'today',
  );
  const [loading, setLoading] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuId, setMenuId] = useState<string>('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [filterType, setFilterType] = useState(filter.filterType);
  const [inValidValueError, setInvalidValueError] = useState(false);
  const [operator, setOperator] = useState(filter.operator);
  const [isTillDate, setIsTillDate] = useState(filter.isTillDate ?? false);
  const [formatedDate, setFormatedDate] = useState({
    from: '',
    to: '',
  });
  const [alert, setAlert] = useState<TAlert | null>(null);
  const formatDateToYYYYMMDD = (date: unknown): string => {
    const parsedDate = date instanceof Date ? date : new Date(date as string);
    const validDate = isNaN(parsedDate.getTime()) ? new Date() : parsedDate;

    return format(validDate, 'yyyy-MM-dd');
  };

  const fetchFieldData = (type: string) => {
    let url: string;
    let bodyData: any;
    url = `filter-options?dbconnectionid=${dbConnectionId}`;
    bodyData = {
      exprType: filterFieldData.current.operator,
      tableId: filterFieldData.current.tableId,
      fieldName: filterFieldData.current.fieldName,
      dataType: filterFieldData.current.dataType,
      filterOption: 'allValues',
      tableName: filterFieldData.current.tableName,
      schemaName: filterFieldData.current.schema,
      dbName: filter.database,
      schema: filter.schema,
      flatFileId: flatFileId,
      ...(filterFieldData.current.dataType === 'timestamp' ||
      filterFieldData.current.dataType === 'date'
        ? { timeGrain: filterFieldData.current.timeGrain || 'year' }
        : {}),
    };
    return FetchData({
      requestType: 'withData',
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: bodyData,
    });
  };
  const getFormatedDate = async () => {
    let url = 'relative-filter';
    const {
      tableId,
      fieldName,
      dataType,
      timeGrain,
      tableName,
      relativeCondition,
      userSelection,
      schema,
      database,
    } = filterFieldData.current;

    const filterTable: {
      tableId: string;
      fieldName: string;
      dataType: string;
      timeGrain: string;
      schemaName: string;
      displayName?: string;
      flatFileId?: string;
      tableName?: string;
      dbName?: string;
    } = {
      tableId,
      fieldName,
      dataType,
      timeGrain: 'date',
      tableName,
      schemaName: schema,
      dbName: database,
    };
    if (filterFieldSchema !== '') {
      filterTable.displayName = `${timeGrain} of ${fieldName}`;
    } else {
      filterTable.flatFileId = flatFileId;
      filterTable.tableName = tableName!;
    }
    const body = {
      filterTable,
      from: relativeCondition?.from,
      to: relativeCondition?.to,
      anchorDate:
        relativeCondition?.anchorDate === 'specificDate'
          ? formatDateToYYYYMMDD(userSelection[0])
          : relativeCondition?.anchorDate,
    };

    if (filterFieldSchema !== '') {
      url += `?dbconnectionid=${dbConnectionId}`;
    }

    const res = await FetchData({
      requestType: 'withData',
      method: 'POST',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: body,
    });

    if (res.status) {
      const obj = convertKeysToLowercase(res.data[0]);
      setFormatedDate({
        from: obj['fromdate'],
        to: obj['todate'],
      });
    } else {
      setAlert({
        severity: 'error',
        message: 'Error fetching formatted date',
      });
    }
  };
  useEffect(() => {
    /** 
    on initial render modify the state values get required datat for picklist i.e. all Options

    for relativeFilter set fromDate and toDate

    -> pickList state stores values of all available options and userSelected options
    
    */
    if (filterType === 'pickList') {
      filterFieldData.current.operator = 'in';
      (async () => {
        setLoading(true);
        const res: any = await FetchData({
          requestType: 'withData',
          method: 'POST',
          url: `filter-options?dbconnectionid=${dbConnectionId}`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          data: {
            // exprType: filterFieldData.current.operator,
            tableId: filterFieldData.current.tableId,
            fieldName: filterFieldData.current.fieldName,
            dataType: filterFieldData.current.dataType,
            filterOption: 'allValues',
            tableName: filterFieldData.current.tableName,
            schemaName: filterFieldData.current.schema,
            dbName: filter.database,
            schema: filter.schema,
            flatFileId: flatFileId,
            ...(filterFieldData.current.dataType === 'timestamp' ||
            filterFieldData.current.dataType === 'date'
              ? { timeGrain: filterFieldData.current.timeGrain || 'year' }
              : {}),
          },
        });
        if (res && res.status) {
          const key = Object.keys(res.data)[0];
          const values = res.data[key] || [];
          const data = [
            '(All)',
            ...(Array.isArray(values)
              ? values.map((value) =>
                  value !== null
                    ? typeof value === 'boolean'
                      ? value
                        ? 'True'
                        : 'False' // Convert boolean to string
                      : value
                    : '(Blank)',
                )
              : []),
          ];

          filterFieldData.current = {
            ...filterFieldData.current,
            userSelection: filterFieldData.current.userSelection ?? [],
          };
          setPickList({
            allOptions: data,
            userSelection: filterFieldData.current.userSelection ?? [],
          });
          // setInclude(true);
        } else {
          setAlert({
            severity: 'error',
            message: 'Error fetching picklist options',
          });
        }
        setDataSetFilterArray((prevFilters: any) => {
          return prevFilters.map((filter: any) =>
            filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
          );
        });
        setLoading(false);
      })();
    } else if (filterType === 'searchCondition') {
      if (filterFieldData.current.operator === 'in') {
        filterFieldData.current.operator =
          filterFieldData.current.dataType === 'text'
            ? withPatternCollections[0].key
            : 'greaterThan';
      }
      let isValidOperator = true;
      if (
        filterFieldData.current.dataType === 'text' &&
        !searchConditionOperatorText.includes(operator)
      ) {
        isValidOperator = false;
      }
      filterFieldData.current.operator = isValidOperator
        ? filterFieldData.current.operator
        : withPatternCollections[0].key;
      setSearchCondition(filterFieldData.current.operator);
      if (
        filterFieldData.current.dataType === 'date' ||
        filterFieldData.current.dataType === 'timestamp'
      ) {
        setConditionValue(
          filter.userSelection.length > 0
            ? filterFieldData.current.timeGrain === 'date'
              ? new Date(filter.userSelection[0])
              : filter.userSelection[0]
            : '',
        );
        if (filterFieldData.current.operator === 'between') {
          setConditionValue2(
            filter.userSelection.length > 1
              ? filterFieldData.current.timeGrain === 'date'
                ? new Date(filter.userSelection[1])
                : filter.userSelection[1]
              : '',
          );
        }
      } else if (['decimal', 'integer', 'float'].includes(filterFieldData.current.dataType)) {
        setConditionValue(filter.userSelection.length > 0 ? filter.userSelection[0] : '');
        if (filterFieldData.current.operator === 'between') {
          setConditionValue2(filter.userSelection.length > 1 ? filter.userSelection[1] : '');
        }
      } else {
        setConditionValue(filter.userSelection.length > 0 ? filter.userSelection[0] : '');
      }

      setDataSetFilterArray((prevFilters: any) => {
        return prevFilters.map((filter: any) =>
          filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
        );
      });
    } else if (filterType === 'relativeFilter') {
      if (
        (filterFieldData.current.dataType === 'date' ||
          filterFieldData.current.dataType === 'timestamp') &&
        filter.relativeCondition
      ) {
        filterFieldData.current = {
          ...filterFieldData.current,
          relativeCondition: filter.relativeCondition,
        };
        if (
          !['today', 'yesterday', 'tomorrow', 'columnMaxDate'].includes(
            filter.relativeCondition?.anchorDate,
          ) &&
          filterFieldData.current.relativeCondition
        ) {
          const raw = filterFieldData.current.userSelection[0];
          const val = raw instanceof Date ? raw : new Date(raw);

          filterFieldData.current.userSelection[0] = !isNaN(val.getTime()) ? val : new Date();
          filterFieldData.current.relativeCondition.anchorDate = 'specificDate';
        }
        getFormatedDate();
        const val = filterFieldData.current.userSelection[0];
        setConditionValue(val ? new Date(val) : new Date());
      }
      setDataSetFilterArray((prevFilters: any) => {
        return prevFilters.map((filter: any) =>
          filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
        );
      });
    }
  }, [filterType]);
  /**
   * @param uid -> filter id
   * handle filter menu opening
   */
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, uid: string) => {
    if (!canEdit) return;
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
    setMenuId(uid);
  };
  /**
   *
   * @param filterId
   * delete selected filter from dataSetFilterArray
   *
   */
  const handleDelete = (filterId: string) => {
    setDataSetFilterArray((prevArray: any) =>
      prevArray.filter((item: any) => item.uid !== filterId),
    );
  };
  /**
   *
   * @param event
   *
   * change timeGrain  if dataType is date or timestamp only for pickList and searchCondition
   */
  const handleDropDownForDatePatternOnChange = async (event: any) => {
    if (!canEdit) return;
    if (filterFieldData.current.filterType === 'pickList') {
      // setLoading(true);
      // await GetPickListItems();
      filterFieldData.current.timeGrain = event.target.value;

      const res: any = await fetchFieldData('');
      if (res && res.status) {
        const key = Object.keys(res.data)[0];
        const values = res.data[key] || [];
        const data = [
          '(All)',
          ...(Array.isArray(values)
            ? values.map((value) =>
                value !== null
                  ? typeof value === 'boolean'
                    ? value
                      ? 'True'
                      : 'False' // Convert boolean to string
                    : value
                  : '(Blank)',
              )
            : []),
        ];

        filterFieldData.current = {
          ...filterFieldData.current,
          userSelection: [],
        };
        setDataSetFilterArray((prevFilters: any) =>
          prevFilters.map((filter: any) =>
            filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
          ),
        );
        setPickList({
          allOptions: data,
          userSelection: [],
        });
        setLoading(false);
      } else {
        setAlert({
          severity: 'error',
          message: 'Error fetching picklist options',
        });
      }
    } else if (filterFieldData.current.filterType === 'searchCondition') {
      filterFieldData.current.timeGrain = event.target.value;
      setDataSetFilterArray((prevFilters: any) =>
        prevFilters.map((filter: any) =>
          filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
        ),
      );
      setTimeGrain(filterFieldData.current.timeGrain || 'year');
    }
  };

  const handleClose = (type: string, option: string, uid: string) => {
    if (!canEdit) return;
    let updatedObject = filterFieldData.current;
    // if (!filterFieldData.current.filterType) {
    //   updatedObject.includeexclude = "Include";
    // }

    if (type === 'clickOutside') {
      setIsMenuOpen(false);
      return;
    }
    if (type === 'opt2') {
      filterFieldData.current.filterType = option;
      filterFieldData.current.userSelection = [];
      setFilterType(option);
    }
    if (type === 'opt1' && option === 'Include') {
      filterFieldData.current.shouldExclude = false;
      // setInclude(false);
    }
    if (type === 'opt1' && option === 'Exclude') {
      filterFieldData.current.shouldExclude = true;
      // setInclude(true);
    }
    setDataSetFilterArray((prevArray: IFilter[]) =>
      prevArray.map((item) => {
        if (item.uid === uid) {
          let val = option === 'Include' ? false : true;
          updatedObject = {
            ...item,
            [type === 'opt2' ? 'filterType' : 'shouldExclude']: type === 'opt2' ? option : val,
          };

          return updatedObject;
        }
        return item;
      }),
    );
    // setFilterFieldData(updatedObject);

    // if (updatedObject) setObjectToMakeCall(updatedObject);
    setIsMenuOpen(false);
  };

  const handleCustomRequiredValueOnBlur = async (
    val: number | string | Date | null,
    type: string,
    valType?: string,
  ) => {
    if (!canEdit) return;

    if (val === null) return;
    if (filterFieldData.current.filterType === 'relativeFilter') {
      // @ts-ignore
      const strDate = format(val, 'yyyy-MM-dd');
      filterFieldData.current.userSelection[0] = strDate;
      getFormatedDate();
      setConditionValue(val);
      setDataSetFilterArray((prevArray: IFilter[]) => {
        return prevArray.map((item) =>
          item.uid === filterFieldData.current.uid ? filterFieldData.current : item,
        );
      });
    } else {
      let temp_val = val;
      if (valType && valType === 'date') {
        // @ts-ignore
        temp_val = format(temp_val, 'yyyy-MM-dd');
      } else {
        temp_val = Number(val);
      }
      if (filterFieldData.current.operator === 'between') {
        if (type === 'lower_limit') {
          filterFieldData.current.userSelection[0] = temp_val;
          setConditionValue(val);
        } else {
          filterFieldData.current.userSelection[1] = temp_val;
          setConditionValue2(val);
        }
      } else {
        //@ts-ignore
        filterFieldData.current.userSelection = isNaN(temp_val) ? [val] : [temp_val];
        setConditionValue(val);
      }
      if (valType && valType === 'date') {
        if (
          filterFieldData.current.userSelection[0] !== null &&
          filterFieldData.current.userSelection[1] !== null &&
          new Date(filterFieldData.current.userSelection[0]) >
            new Date(filterFieldData.current.userSelection[1])
        ) {
          setInvalidValueError(true);
          return;
        }
      } else if (
        filterFieldData.current.userSelection[0] !== null &&
        filterFieldData.current.userSelection[1] !== null &&
        filterFieldData.current.userSelection[0] > filterFieldData.current.userSelection[1]
      ) {
        setInvalidValueError(true);
        return;
      }
      setInvalidValueError(false);
      setDataSetFilterArray((prevArray: IFilter[]) => {
        return prevArray.map((item) =>
          item.uid === filterFieldData.current.uid ? filterFieldData.current : item,
        );
      });
    }
  };

  const ExpandCollaseIconSwitch = () => {
    return isCollapsed ? (
      <ChevronRightIcon
        style={{ height: '18px', width: '18px', color: '#999999' }}
        onClick={(e) => {
          setIsCollapsed(false);
        }}
      />
    ) : (
      <KeyboardArrowDownIcon
        style={{ height: '18px', width: '18px', color: '#999999' }}
        onClick={(e) => {
          setIsCollapsed(true);
        }}
      />
    );
  };

  const handleRelativeValueOnBlur = (val: number | string | Date, exprType: string) => {
    if (!canEdit) return;

    if (val === null) return;
    if (exprType === 'value_from' && filterFieldData.current.relativeCondition) {
      filterFieldData.current.relativeCondition.from[1] = val as string;
      // setFromDate((prev) => ({ ...prev, value: val }));
    } else if (exprType === 'specific_date') {
      filterFieldData.current.userSelection[0] = val as string;
      setConditionValue(val);
    } else if (filterFieldData.current.relativeCondition) {
      filterFieldData.current.relativeCondition.to[1] = val as string;
      // setToDate((prev) => ({ ...prev, value: val }));
    }
    getFormatedDate();
    setDataSetFilterArray((prevArray: IFilter[]) =>
      prevArray.map((item) =>
        item.uid === filterFieldData.current.uid ? filterFieldData.current : item,
      ),
    );
  };

  const handleDropDownForPatternOnChange = async (event: any) => {
    if (!canEdit) return;

    filterFieldData.current.operator = event.target.value;
    setSearchCondition(event.target.value);
    setConditionValue('');
    setConditionValue2('');
    setDataSetFilterArray((prevFilters: any) =>
      prevFilters.map((filter: any) =>
        filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
      ),
    );
  };
  /**
   *
   * @param event
   * @param type
   *
   * for relative fi;ter this method modifies the filter values of filter.field.current and datasetFilterArray
   */
  const handleDropDownForRelativePatternOnChange = (event: any, type: string) => {
    if (!canEdit) return;

    // type from/to iindicates te year month week etc
    if (type === 'from' && filterFieldData.current?.relativeCondition) {
      filterFieldData.current.relativeCondition.from[2] = event.target.value;
    } else if (type === 'to' && filterFieldData.current?.relativeCondition) {
      filterFieldData.current.relativeCondition.to[2] = event.target.value;
    } else if (type === 'anchorDate' && filterFieldData.current?.relativeCondition) {
      filterFieldData.current.relativeCondition.anchorDate = event.target.value;
    } else if (
      // type value_from /value_to denotes the  number field in relaive filter
      type === 'value_from' &&
      filterFieldData.current?.relativeCondition
    ) {
      filterFieldData.current.relativeCondition.from[1] = event.target.value;
    } else if (type === 'value_to' && filterFieldData.current?.relativeCondition) {
      filterFieldData.current.relativeCondition.to[1] = event.target.value;
    } else if (type === 'last_current_next_to' && filterFieldData.current?.relativeCondition) {
      filterFieldData.current.relativeCondition.to[0] = event.target.value;
    } else if (type === 'last_current_next_from' && filterFieldData.current?.relativeCondition) {
      filterFieldData.current.relativeCondition.from[0] = event.target.value;
    }
    setAnchorDate(filterFieldData.current.relativeCondition?.anchorDate || '');
    getFormatedDate();
    setDataSetFilterArray((prevFilters: any) =>
      prevFilters.map((filter: any) =>
        filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
      ),
    );
  };

  const handleCBChange = (event: any) => {
    if (!canEdit) return;
    if (event.target.name.toString() === '(All)') {
      if (event.target.checked) {
        filterFieldData.current = {
          ...JSON.parse(JSON.stringify(filterFieldData.current)),
          userSelection: [
            ...picklist.allOptions
              .filter((item: any) => item !== '(All)')
              .map((option: any) =>
                option === '(Blank)' ? null : option === '(Empty)' ? '' : option,
              ),
          ],
        };
        setPickList((prev: any) => ({
          ...prev,
          userSelection: [...prev.allOptions],
        }));
      } else {
        setPickList((prev: any) => ({
          ...prev,
          userSelection: [],
        }));
        filterFieldData.current = {
          ...JSON.parse(JSON.stringify(filterFieldData.current)),
          userSelection: [],
        };
      }
    } else {
      if (event.target.checked) {
        const newSelection = [...filterFieldData.current.userSelection];
        if (!isNaN(event.target.name) && isFinite(event.target.name)) {
          let _name = event.target.name;
          if (_name.includes('.')) {
            _name = parseFloat(event.target.name);
          } else {
            _name = parseInt(event.target.name);
          }
          if (_name) newSelection.push(_name);
        } else {
          const selected =
            event.target.name === '(Blank)'
              ? null
              : event.target.name === '(Empty)'
                ? ''
                : event.target.name;
          newSelection.push(selected);
        }
        filterFieldData.current = {
          ...JSON.parse(JSON.stringify(filterFieldData.current)),
          userSelection: newSelection,
        };
        if (newSelection.length === picklist.allOptions.length - 1) {
          setPickList((prev: any) => {
            return {
              ...prev,
              userSelection: ['(All)', ...newSelection],
            };
          });
        } else {
          setPickList((prev: any) => {
            return {
              ...prev,
              userSelection: [...newSelection],
            };
          });
        }
      } else {
        let modified: string[] | number[] | Date[] = [];
        let idx = filterFieldData.current.userSelection.findIndex((item: any) => {
          let comparable = item;

          if (comparable === null) comparable = '(Blank)';
          else if (comparable === '') comparable = '(Empty)';

          return String(comparable) === event.target.name;
        });
        if (idx >= 0) {
          filterFieldData.current.userSelection.splice(idx, 1);
          modified = filterFieldData.current.userSelection;
        }
        // console.log(modified, selected);
        // filterFieldData.current = {
        //   ...JSON.parse(JSON.stringify(filterFieldData.current)),
        //   userSelection: modified,
        // };
        setPickList((prev: any) => {
          return {
            ...prev,
            userSelection: modified,
          };
        });
      }
    }
    setDataSetFilterArray((prevFilters: any) =>
      prevFilters.map((filter: any) =>
        filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
      ),
    );
  };

  const handleChangeTillDate = (e: any) => {
    if (!canEdit) return;

    if (e.target.checked) {
      filterFieldData.current.isTillDate = true;
      setIsTillDate(true);
    } else {
      filterFieldData.current.isTillDate = false;
      setIsTillDate(false);
    }
    setDataSetFilterArray((prevFilters: any) =>
      prevFilters.map((filter: any) =>
        filter.uid === filterFieldData.current.uid ? filterFieldData.current : filter,
      ),
    );
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div
          className="axisFilterField"
          style={{
            width: '100%',
            display: 'flex',
            padding: '1px',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '3px 0px 6px',
            color: !isCollapsed ? 'rgb(175, 153, 219)' : '',
            border: !isCollapsed ? '1px solid rgb(175, 153, 219)' : '',
            fontWeight: !isCollapsed ? 'bold' : '',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '130px',
              justifyContent: 'center',
              textOverflow: 'ellipsis',
            }}
          >
            {/* Remove column */}
            <button
              disabled={!canEdit}
              title="Remove field"
              style={{
                backgroundColor: 'white',
                outline: 'none',
                border: 'none',
              }}
              onClick={() => canEdit && handleDelete(filter.uid)}
            >
              <CloseRoundedIcon className="columnClose" style={{ fontSize: '11px' }} />
            </button>

            {/* Filter column name */}
            <Typography
              variant="body2"
              sx={{
                flexGrow: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: palette.primary.contrastText,
                fontSize: fontSize.medium,
              }}
            >
              {filter.fieldName}
            </Typography>
          </div>
          {/* More options icon */}
          <div style={{ display: 'flex' }}>
            <button
              disabled={!canEdit}
              style={{
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                outline: 'none',
                border: 'none',
              }}
              onClick={(event) => handleMenuClick(event, filter.uid)}
            >
              <MoreVertIcon
                style={{
                  height: '18px',
                  width: '18px',
                  color: '#999999',
                }}
              />
            </button>

            {/* Expand/collapse icon */}
            <button
              type="button"
              className="buttonCommon columnDown"
              title={isCollapsed ? 'Expand' : 'Collapse'}
            >
              <ExpandCollaseIconSwitch />
            </button>
          </div>

          {/* Conditional Menu */}
          {isMenuOpen && menuId === filter.uid && (
            <MenuOption
              open={isMenuOpen}
              anchorEl={anchorEl}
              onClose={handleClose}
              filterFieldData={filterFieldData}
              uid={filter.uid}
            />
          )}
        </div>
        {/* Conditional rendering based on isCollapsed */}
        {/* {loading ? <LoadingPopover /> : null} */}
        {!isCollapsed ? (
          <div
            className="UserSelectionDiv"
            style={
              inValidValueError ? { border: '2px red solid', backgroundColor: 'lightpink' } : {}
            }
          >
            {filterFieldData.current.dataType === 'timestamp' ||
            filterFieldData.current.dataType === 'date' ? (
              <div
                className="CustomRequiredField"
                style={{
                  backgroundColor: 'white',
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: '8px',
                  paddingTop: '2px',
                }}
              >
                {filterFieldData.current.filterType === 'pickList' ? (
                  <DropDownForDatePattern
                    items={datePatternCollections}
                    value={filterFieldData.current.timeGrain || 'year'}
                    handleDropDownForDatePatternOnChange={handleDropDownForDatePatternOnChange}
                    from="datasetFilter"
                  />
                ) : filterFieldData.current.filterType === 'searchCondition' ? (
                  <DropDownForDatePattern
                    value={filterFieldData.current.timeGrain || 'year'}
                    handleDropDownForDatePatternOnChange={handleDropDownForDatePatternOnChange}
                    items={datePatternSearchConditionCollections}
                    from="datasetFilter"
                  />
                ) : null}
              </div>
            ) : null}

            {filterFieldData.current.filterType === 'pickList' ? (
              <>
                <SelecPickListCard
                  handleCBChange={handleCBChange}
                  allOptions={picklist?.allOptions}
                  userSelection={picklist?.userSelection ?? []}
                  shouldExclude={filterFieldData.current.shouldExclude}
                  loading={loading}
                  from="datasetFilter"
                  disabled={!canEdit}
                ></SelecPickListCard>
                {filterFieldData.current.dataType === 'timestamp' ||
                filterFieldData.current.dataType === 'date' ? (
                  <SelecTillDate
                    isDisabled={!canEdit}
                    shouldExclude={filterFieldData.current.shouldExclude}
                    timeGrain={filterFieldData.current.timeGrain}
                    isChecked={isTillDate}
                    handleChangeTillDate={handleChangeTillDate}
                  ></SelecTillDate>
                ) : null}
              </>
            ) : filterFieldData.current.filterType === 'searchCondition' ? (
              <>
                <CustomCard
                  filterFieldData={filterFieldData}
                  handleCustomRequiredValueOnBlur={handleCustomRequiredValueOnBlur}
                  handleDropDownForPatternOnChange={handleDropDownForPatternOnChange}
                  dataType={filterFieldData.current.dataType}
                  operator={filterFieldData.current.operator}
                  shouldExclude={filterFieldData.current.shouldExclude}
                  timeGrain={filterFieldData.current.timeGrain}
                  value={searchCondition}
                  inputValue={conditionValue}
                  inputValueGreaterThanOrEqualTo={conditionValue}
                  inputValueLessThanOrEqualTo={conditionValue2}
                  from="datasetFilter"
                ></CustomCard>
                {(filterFieldData.current.dataType === 'timestamp' ||
                  filterFieldData.current.dataType === 'date') &&
                filterFieldData.current.operator === 'between' ? (
                  <SelecTillDate
                    isDisabled={!canEdit || filterFieldData.current.userSelection.length < 2}
                    shouldExclude={filterFieldData.current.shouldExclude}
                    timeGrain={filterFieldData.current.timeGrain}
                    isChecked={isTillDate}
                    handleChangeTillDate={handleChangeTillDate}
                  ></SelecTillDate>
                ) : null}
              </>
            ) : (
              <>
                <SelecRelativeFilterCard
                  filterFieldData={filterFieldData}
                  handleCustomRequiredValueOnBlur={handleRelativeValueOnBlur}
                  handleDropDownForPatternOnChange={handleDropDownForRelativePatternOnChange}
                  fromDate={formatedDate.from}
                  toDate={formatedDate.to}
                  anchorDate={filterFieldData.current.relativeCondition?.anchorDate}
                  specificDate={conditionValue}
                  relativeConditionFromType={filterFieldData.current.relativeCondition?.from[0]}
                  relativeConditionToType={filterFieldData.current.relativeCondition?.to[0]}
                  from="datasetFilter"
                  disabled={!canEdit}
                ></SelecRelativeFilterCard>
              </>
            )}
          </div>
        ) : null}
      </div>
      {alert && (
        <NotificationDialog
          onCloseAlert={() => setAlert(null)}
          severity={alert.severity}
          testMessage={alert.message}
          openAlert={!!alert}
        />
      )}
    </>
  );
};

export default FilterElement;
